import { Flex, PrimarySecondaryPage, OnboardingLayout } from "@wayflyer/flyui";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";
import { OnboardingStepper } from "onboarding";

import { DocumentUploadSupportingContent } from "../../../components";
import { useDocumentQuery } from "../../../queries/document-uploads/queries";
import { useFundingApplication } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import {
  DocumentNavigationGroup,
  PoolBancarioDocumentUpload,
  useDocumentNavigationActions,
  MESSAGES,
} from "../components";

export const PoolBancarioDocumentUploadPage = () => {
  const intl = useIntl();
  const isNewOnboardingFlowEnabled = useFeatureFlagEnabled("enable_new_onboarding_setup_flow");
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplicationData } = useFundingApplication(customerDomain);
  const { data: uploadedDocuments } = useDocumentQuery(customerDomain, fundingApplicationData.id);
  const hasUploadedDocuments = !!uploadedDocuments?.filter(
    (doc) => doc.documentType === UploadDocumentType.POOL_BANCARIO
  ).length;

  const { primaryAction, secondaryAction } = useDocumentNavigationActions({
    forType: UploadDocumentType.POOL_BANCARIO,
  });

  if (isNewOnboardingFlowEnabled) {
    return (
      <OnboardingLayout
        variant="wide"
        titleSlot={<OnboardingStepper currentStep={4} />}
        title={intl.formatMessage(MESSAGES.poolBancarioTitle)}
        actions={{ primary: primaryAction, secondary: secondaryAction }}
      >
        <Flex maxWidth="550px">
          <PoolBancarioDocumentUpload />
        </Flex>
      </OnboardingLayout>
    );
  }

  const PoolBancarioDocumentUploadPrimary = (
    <Flex direction="column" gap="8">
      <PoolBancarioDocumentUpload />
      <DocumentNavigationGroup
        isStepComplete={hasUploadedDocuments || fundingApplicationData.isPoolBancarioSkipped === true}
        forType={UploadDocumentType.POOL_BANCARIO}
      />
    </Flex>
  );

  return (
    <PrimarySecondaryPage
      titleSlot={<OnboardingStepper currentStep={4} />}
      showStepperBackground={true}
      title={intl.formatMessage(MESSAGES.poolBancarioTitle)}
      primaryContent={PoolBancarioDocumentUploadPrimary}
      secondaryContent={<DocumentUploadSupportingContent />}
    />
  );
};
